<template>
  <div class="font-16 pb-0" :class="noPadding ? '' : 'px-13 py-9'">
    <p>
      Legal expenses covers you for up to £100,000 for legal costs in pursuing
      or defending a range of claims.
    </p>

    <p class="font-weight-bold text-uppercase mt-8">
      Examples of what's covered:
    </p>
    <ul>
      <li>Property legal disputes</li>
      <li>Contract disputes</li>
      <li>Rent recovery</li>
    </ul>

    <p class="font-weight-bold text-uppercase mt-8">
      Examples of what's <u>not</u> covered:
    </p>

    <ul>
      <li>Insured events that started before the policy begins</li>
      <li>
        Fines, penalties or any damages that you have to pay as a result of
        legal action
      </li>
      <li>Any claim where reasonable prospects of success do not exist</li>
    </ul>

    <p class="mt-4">
      Please see the policy terms and conditions for further information on our
      legal expenses cover. These can be found on our website here:
      <a
        href="https://www.paymentshield.co.uk/types-of-cover/landlords-insurance"
        target="_blank"
      >
        Paymentshield | Landlords Insurance
        <v-icon small class="ml-1">mdi-open-in-new</v-icon>
      </a>
    </p>
    <div class="d-flex justify-center">
      <BaseButton
        depressed
        text="OK"
        rounded
        width="100%"
        max-width="420"
        height="60"
        dense
        :color="'psorange'"
        class="font-weight-bold font-20"
        @click="$emit('click:hideDialog')"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: "DialogContentWhatsIncludedLegalExpenses",
  props: {
    noPadding: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    BaseButton: () => import("@/components/BaseComponents/BaseButton.vue"),
  },
};
</script>

<style lang="scss" scoped></style>
